import type { CertGenParams } from '@yandex-int/k-common';

export const GLAutumn2022 = ({
    school_name: schoolName,
    first_name: firstName,
    middle_name: middleName,
    last_name: lastName,
}: CertGenParams) => {
    return `
        <!DOCTYPE html>
<html>
    <head>
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <style>
            @font-face {
                font-family: 'YS Text';
                src: url('https://yastatic.net/s3/home/fonts/ys/1/text-light.woff2') format('woff2'),
                    url('https://yastatic.net/s3/home/fonts/ys/1/text-light.woff') format('woff');
                font-weight: 300;
                font-style: normal;
            }

            @font-face {
                font-family: 'YS Text';
                src: url('https://yastatic.net/s3/home/fonts/ys/1/text-regular.woff2') format('woff2'),
                    url('https://yastatic.net/s3/home/fonts/ys/1/text-regular.woff') format('woff');
                font-weight: 400;
                font-style: normal;
            }

            @font-face {
                font-family: 'YS Text';
                src: url('https://yastatic.net/s3/home/fonts/ys/1/text-medium.woff2') format('woff2'),
                    url('https://yastatic.net/s3/home/fonts/ys/1/text-medium.woff') format('woff');
                font-weight: 500;
                font-style: normal;
            }

            @font-face {
                font-family: 'YS Text';
                src: url('https://yastatic.net/s3/home/fonts/ys/1/text-bold.woff2') format('woff2'),
                    url('https://yastatic.net/s3/home/fonts/ys/1/text-bold.woff') format('woff');
                font-weight: bold;
                font-style: normal;
            }

            @page {
                size: 210mm 297mm;
                margin: 0;
            }

            @media print {
                html,
                body {
                    width: 210mm;
                    height: 297mm;

                    color-adjust: exact;
                    print-color-adjust: exact;
                    -webkit-print-color-adjust: exact;
                }
            }

            html {
                position: relative;

                margin: 0;
                padding: 0;
            }

            body {
                margin: 0;

                color: #000;

                font-family: 'YS Text';
            }

            .page {
                position: relative;

                overflow: hidden;

                box-sizing: border-box;

                width: 210mm;
                height: 297mm;

                background: #fff;

                page-break-after: always;
            }

            .page-background {
                position: absolute;

                z-index: 1;

                width: 100%;
                height: 100%;

                background-image: url('https://avatars.mdst.yandex.net/get-schoolbook-images/1400945/8750db5da513610cdfbd33da9b14988a/orig');
                background-repeat: no-repeat;
                background-position: bottom;

                background-size: contain;
            }

            .page-content {
                display: grid;
                grid-template-columns:
                    calc(404mm * 210 / 638)
                    calc(234mm * 210 / 638);

                height: 100%;
            }

            .letter-info {
                padding-top: calc(39mm * 210 / 638);
                padding-right: calc(48mm * 210 / 638);
                padding-left: calc(39mm * 210 / 638);

                z-index: 2;
            }

            .book-logo {
                height: calc(24mm * 210 / 638);
                margin-bottom: calc(32mm * 210 / 638);
            }

            .title {
                margin-bottom: calc(8mm * 210 / 638);

                font-size: calc(32mm * 210 / 638);
                line-height: calc(38mm * 210 / 638);
                font-weight: 500;
            }

            .olympiad-info {
                margin-bottom: calc(12mm * 210 / 638);

                font-size: calc(12mm * 210 / 638);
                line-height: calc(16mm * 210 / 638);
            }

            .grade {
                display: inline-flex;
                align-items: center;

                height: calc(27mm * 210 / 638);

                padding: 0 calc(12mm * 210 / 638);

                border: calc(1mm * 210 / 638) solid #4eb4ff;
                border-radius: calc(14mm * 210 / 638);

                color: #4eb4ff;

                font-size: calc(13mm * 210 / 638);
                line-height: calc(21mm * 210 / 638);

                white-space: nowrap;
            }

            .student-data {
                margin-top: calc(32mm * 210 / 638);

                font-size: calc(27mm * 210 / 638);
                line-height: calc(32mm * 210 / 638);
            }

            .school-data {
                margin-top: calc(12mm * 210 / 638);

                font-size: calc(12mm * 210 / 638);
                line-height: calc(16mm * 210 / 638);
            }

            .description {
                margin-top: calc(32mm * 210 / 638);

                font-size: calc(14mm * 210 / 638);
                line-height: calc(22mm * 210 / 638);
            }

            .date {
                position: absolute;
                top: calc(10mm * 210 / 638);
                left: calc(-43mm * 210 / 638);

                transform: rotate(180deg);
                white-space: nowrap;
                text-transform: uppercase;

                color: #CFF5F6;

                font-size: calc(48mm * 210 / 638);
                font-weight: bold;
                line-height: calc(56mm * 210 / 638);
                writing-mode: vertical-lr;
            }

            .service-info {
                position: relative;

                padding-top: calc(39mm * 210 / 638);
                padding-left: calc(30mm * 210 / 638);

                background-color: #CFF5F6;
            }

            .place {
                margin-bottom: calc(230mm * 210 / 638);

                font-size: calc(12mm * 210 / 638);
                line-height: calc(16mm * 210 / 638);
            }

            .signature__marker {
                margin-bottom: calc(8mm * 210 / 638);

                width: calc(56mm * 210 / 638);
                height: calc(84mm * 210 / 638);
            }

            .signature__name {
                margin-bottom: calc(8mm * 210 / 638);

                font-size: calc(13mm * 210 / 638);
                line-height: calc(15mm * 210 / 638);
            }

            .signature__info {
                font-size: calc(10mm * 210 / 638);
                line-height: calc(14mm * 210 / 638);
            }
        </style>
    </head>
    <body>
        <div class="page">
            <div class="page-background"></div>

            <div class="page-content">
                <div class="letter-info">
                    <img
                        src="https://e7n.s3.yandex.net/static/education/olymps/logo.png"
                        alt="book-logo"
                        class="book-logo"
                    />

                    <div class="title">
                        Благодарственное<br />
                        письмо
                    </div>

                    <div class="olympiad-info">за участие в математической олимпиаде для 1–11 классов</div>

                    <div class="student-data">
                        ${lastName ? `<div>${lastName}</div>` : ''}
                        ${firstName ? `<div>${firstName}</div>` : ''}
                        ${middleName ? `<div>${middleName}</div>` : ''}
                    </div>

                    ${
                        schoolName
                            ? `<div class="school-data">
                                ${schoolName}
                                </div>`
                            : ''
                    }

                    <div class="description">
                        Уважаемый учитель!<br />
                        Благодарим Вас за вклад в развитие<br />
                        олимпиадного движения и участие Ваших<br />
                        учеников в математической олимпиаде<br />
                        от Яндекс Учебника для 1-11 классов.
                    </div>
                </div>

                <div class="service-info">
                    <div class="date">Осень 2022</div>

                    <div class="place">Москва, 2022</div>

                    <div class="signature">
                        <img
                            src="https://e7n.s3.yandex.net/static/education/olymp2022/letters/moskvichev-sign.svg"
                            alt="moskvichev-sign"
                            class="signature__marker"
                        />
                        <div class="signature__descr">
                            <div class="signature__name">А. М. Москвичев</div>
                            <div class="signature__info">
                                Руководитель сервиса<br />
                                Яндекс Учебник
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </body>
</html>
    `;
};
